module.exports = require("./ckb.d.ts");